import { AdminLearningContentRow } from '../types/domain';

const CELL_KEYS: (keyof AdminLearningContentRow)[] = [
  'publisher',
  'track_text',
  'seq_text',
  'unit_text',
  'learning_text',
  'page_text',
  'assistant_page_text',
  'target_lesson_text',
  'total_lesson_text',
  'material_text',
  'achievement_text',
  'record_cross_curricular_text',
  'record_memo_text',
  'record_evaluation_text',
];

/** 표 편집 열 중 하나라도 공백이 아닌 값이 있으면 true */
export function adminLearningContentRowHasCellData(row: AdminLearningContentRow): boolean {
  return CELL_KEYS.some((key) => String(row[key] ?? '').trim().length > 0);
}
